import {
  Flex,
  IconArrowOpenDownLine,
  IconArrowOpenUpLine,
  IconButton,
  IconEditLine,
  IconTrashLine,
  Pill,
  Text,
  Tooltip,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { ApDataContext } from "../../../../views/Plan";
import { Card } from "../../../Card";
import { DialogYesNo } from "../../../DialogYesNo/DialogYesNo";
import { MeasureForm } from "../ComponentForms/MeasureForm";

const EmbeddedDashboardCard = ({ measure, lastMeasure, inTemplate }) => {
  const {
    measureIndex,
    sectionIndex,
    handleDeleteMeasure,
    setSections,
    extraData,
  } = useContext(ApDataContext);
  const { t } = useTranslation();
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const moveMeasureUp = () => {
    setSections((prev) =>
      prev.map((section, i) =>
        i === sectionIndex
          ? {
              ...section,
              measures: section.measures.map((m, j) =>
                j === measureIndex
                  ? section.measures[measureIndex - 1]
                  : j === measureIndex - 1
                    ? section.measures[measureIndex]
                    : m
              ),
            }
          : section
      )
    );
  };

  const moveMeasureDown = () => {
    setSections((prev) =>
      prev.map((section, i) =>
        i === sectionIndex
          ? {
              ...section,
              measures: section.measures.map((m, j) =>
                j === measureIndex
                  ? section.measures[measureIndex + 1]
                  : j === measureIndex + 1
                    ? section.measures[measureIndex]
                    : m
              ),
            }
          : section
      )
    );
  };

  return (
    <>
      <Card style={{ backgroundColor: "#FFFFFF" }}>
        <Flex wrap="wrap" alignItems="start">
          <Flex.Item>
            <Pill color="info">{t("embeddedDashboard.embeddedDashboard")}</Pill>
          </Flex.Item>
          {!inTemplate && (
            <Flex.Item shouldGrow textAlign="end">
              <IconButton
                renderIcon={IconArrowOpenUpLine}
                screenReaderLabel={t("measures.moveMeasureUp")}
                size="small"
                onClick={moveMeasureUp}
                disabled={measureIndex === 0}
              />
            </Flex.Item>
          )}
          {!inTemplate && (
            <Flex.Item margin="0 small">
              <IconButton
                renderIcon={IconArrowOpenDownLine}
                screenReaderLabel={t("measures.moveMeasureDown")}
                size="small"
                onClick={moveMeasureDown}
                disabled={!!lastMeasure}
              />
            </Flex.Item>
          )}
          {!extraData?.plan?.from_template && (
            <Flex.Item shouldGrow={inTemplate} textAlign={inTemplate && "end"}>
              <Tooltip
                renderTip={t("measures.edit")}
                on={["hover", "focus"]}
                placement="bottom"
              >
                <IconButton
                  size="small"
                  renderIcon={IconEditLine}
                  screenReaderLabel={t("measures.edit")}
                  onClick={() => setEditModal(true)}
                />
              </Tooltip>
            </Flex.Item>
          )}
          {!inTemplate && (
            <Flex.Item margin="0 0 0 small">
              <Tooltip
                renderTip={t("measures.delete")}
                on={["hover", "focus"]}
                placement="bottom"
              >
                <IconButton
                  color="danger"
                  size="small"
                  screenReaderLabel={t("measures.delete")}
                  renderIcon={IconTrashLine}
                  onClick={() => setDeleteModal(true)}
                />
              </Tooltip>
            </Flex.Item>
          )}
          <Flex.Item size="100%" padding="x-small 0 0 0">
            <Text as="div" size="small" lineHeight="double">
              <Text weight="bold" size="small">
                {t("assessment.name")}:{" "}
              </Text>
              {measure.name}
            </Text>
          </Flex.Item>
          {!!measure.description && (
            <Flex.Item size="100%">
              <Text as="div" size="small" lineHeight="double">
                <Text weight="bold" size="small">
                  {t("embeddedDashboard.description")}:{" "}
                </Text>
                {measure.description}
              </Text>
            </Flex.Item>
          )}
          <Flex.Item size="100%">
            <Text as="div" size="small" lineHeight="double" wrap="break-word">
              <Text weight="bold" size="small">
                {t("embeddedDashboard.dashURL")}:{" "}
              </Text>
              {measure.url ? (
                measure.url
              ) : (
                <Text size="small" fontStyle="italic">
                  {t("global.none")}
                </Text>
              )}
            </Text>
          </Flex.Item>
        </Flex>
      </Card>
      <DialogYesNo
        message={t("measures.deleteConfirm")}
        openStatus={deleteModal}
        onClickNo={() => setDeleteModal(false)}
        onClickYes={() => handleDeleteMeasure(measure, sectionIndex)}
      />
      <MeasureForm
        openModal={editModal}
        setOpenModal={setEditModal}
        courseLevels={extraData.courseLevels}
        assignmentTypes={extraData.assignmentTypes}
        acSubs={extraData.acSubs}
        planId={extraData.plan?.id}
        allCycles={extraData.cycles}
        programs={extraData.programs}
        measure={measure}
        inTemplate={inTemplate}
      />
    </>
  );
};

export default EmbeddedDashboardCard;
